/*
 * @Author: sunzhenyu
 * @Description: 鉴权相关逻辑
 * @Date: 2022-08-22 14:54:36
 * @Last Modified by: sunzhenyu
 * @Last Modified time: 2022-08-22 17:01:32
 */
import { notification } from 'antd';
import React, { FC } from 'react';
import { UserStatusEnum } from './data';
import { useAuth } from './index';

const AuthLayout = (props) => {
  const { user, login } = useAuth();

  if (!(user && user.isLogin)) {
    if (user?.disableFlag === UserStatusEnum.DISABLED) {
      notification.error({ message: user.msg ?? '用户已被禁用！' });
      return <></>;
    } else {
      login();
    }
  }

  return <>{props.children}</>;
};

export default AuthLayout;
